import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {auth, fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/pinterest-account.constant";

export {
    addPinterestAccounts,
    addSinglePinterestAccount,
    updateSinglePinterestAccount,
    getSinglePinterestAccount,
    getAllPinterestAccounts,
    getPinterestAccountsForCurrentUser,
    searchPinterestAccounts,
    searchPinterestAccountsWithSearchCriteria,
    preparePinterestAccountsList
}

const collectionName = 'pinterest-accounts';
const collectionReference = collection(fireStoreDB, collectionName);

const addPinterestAccounts = (pinterestAccounts) => {
    return Promise.map(pinterestAccounts, async pinterestAccount => {
        await addSinglePinterestAccount(pinterestAccount);
    });
}

const addSinglePinterestAccount = (pinterestAccount) => {
    pinterestAccount.createdAt = new Date();
    pinterestAccount.updatedAt = pinterestAccount.createdAt;
    return addDoc(collectionReference, pinterestAccount);
}

const updateSinglePinterestAccount = (pinterestAccount) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestAccount.id);
    pinterestAccount.updatedAt = new Date();
    return setDoc(documentReference, pinterestAccount);
}

const getSinglePinterestAccount = async (pinterestAccountId) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestAccountId);
    const pinterestAccountDoc = await getDoc(documentReference);
    return prepareSinglePinterestAccount(pinterestAccountDoc);
}

const getPinterestAccountsForCurrentUser = async () => {
    const userId = auth.currentUser.uid;
    let searchQuery = query(collectionReference);
    searchQuery = query(searchQuery, where("user.id", "==", userId));
    const pinterestAccountsResult = await getDocs(searchQuery);
    return preparePinterestAccountsList(pinterestAccountsResult);
}

const getAllPinterestAccounts = async () => {
    let searchQuery = query(collectionReference);
    const pinterestAccountsResult = await getDocs(searchQuery);
    return preparePinterestAccountsList(pinterestAccountsResult);
}

const searchPinterestAccounts = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const pinterestAccountResult = await getDocs(searchQuery);
    return preparePinterestAccountsList(pinterestAccountResult);
}

const searchPinterestAccountsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPinterestAccountsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const pinterestAccountResult = await getDocs(searchQuery);
    return preparePinterestAccountsList(pinterestAccountResult);
}

const preparePinterestAccountsList = (pinterestAccountResult) => {
    const pinterestAccountsList = [];

    _.forEach(pinterestAccountResult.docs, pinterestAccountDoc => {
        pinterestAccountsList.push(prepareSinglePinterestAccount(pinterestAccountDoc));
    });

    return pinterestAccountsList;
}


const prepareSinglePinterestAccount = (pinterestAccountDoc) => {
    const pinterestAccount = pinterestAccountDoc.data();
    pinterestAccount.id = pinterestAccountDoc.id;
    return pinterestAccount;
}
